import r from "react";
import n from "./index25.mjs";
import { ErrorBanner as a } from "./index26.mjs";
const s = ({ description: e, onDismiss: t }) => /* @__PURE__ */ r.createElement("div", { className: n.banner_container, "data-testid": "error-banner" }, /* @__PURE__ */ r.createElement(a, { description: e, onDismiss: t }));
export {
  s as ErrorBannerContainer
};
